import { GrammarSimpleEventTypeLegacy, SimpleEventTypeLegacy } from '@verantos-dev/types-cohorts';

export const transformSimpleEventTypeToGrammarSimpleEventType = (
  simpleEventType: SimpleEventTypeLegacy | undefined
): GrammarSimpleEventTypeLegacy => {
  switch (simpleEventType) {
    case SimpleEventTypeLegacy.CONDITION_OCCURRENCE:
      return GrammarSimpleEventTypeLegacy.CONDITION_OCCURRENCE;
    case SimpleEventTypeLegacy.DRUG_EXPOSURE:
      return GrammarSimpleEventTypeLegacy.DRUG_EXPOSURE;
    case SimpleEventTypeLegacy.PROCEDURE_OCCURRENCE:
      return GrammarSimpleEventTypeLegacy.PROCEDURE_OCCURRENCE;
    case SimpleEventTypeLegacy.MEASUREMENT:
      return GrammarSimpleEventTypeLegacy.MEASUREMENT;
    case SimpleEventTypeLegacy.OBSERVATION:
      return GrammarSimpleEventTypeLegacy.OBSERVATION;
    case SimpleEventTypeLegacy.VISIT_OCCURRENCE:
      return GrammarSimpleEventTypeLegacy.VISIT_OCCURRENCE;
    default:
      throw new Error(`Cannot submit without a simple event type`);
  }
};
